import React, { useEffect, useState } from 'react';
import { familiesAPI } from '../../../services/api';
import toast from 'react-hot-toast';

const FamilyModal = ({ show, onClose, familyId }) => {
  const [family, setFamily] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && familyId) {
      setLoading(true);
      familiesAPI.getById(familyId)
        .then(res => setFamily(res.data.data))
        .catch(() => toast.error('Failed to load family details'))
        .finally(() => setLoading(false));
    } else {
      setFamily(null);
    }
  }, [show, familyId]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
        <button className="absolute top-2 right-2 text-gray-500" onClick={onClose}>&times;</button>
        {loading ? (
          <div>Loading...</div>
        ) : family ? (
          <>
            <h2 className="text-xl font-bold mb-2">{family.family_name || family.family_number}</h2>
            <div className="mb-2">
              <span className="font-medium">Head of Family:</span> {family.head_of_family?.name}
            </div>
            <div className="mb-4">
              <span className="font-medium">Members:</span>
              <ul className="list-disc ml-6">
                {family.members?.map(m => (
                  <li key={m.id}>{m.name} <span className="text-xs text-gray-500">({m.relationship_to_family_head})</span></li>
                ))}
              </ul>
            </div>
            <div className="text-sm text-gray-500">Status: {family.status}</div>
          </>
        ) : (
          <div>No family data.</div>
        )}
      </div>
    </div>
  );
};

export default FamilyModal;
